<div class="card card-long">
    <div class="card-header">
        <ul class="creative-stats">
            <li>
                <span class="stats">{{creative.impressions | number}}</span>
                <span class="stats-label">Impressions</span>
            </li>
            <li>
                <span class="stats">{{creative.completions | number}}</span>
                <span class="stats-label">Completions</span>
            </li>
            <li>
                <span class="stats">{{creative.completionRate}}%</span>
                <span class="stats-label">Completion Rate</span>
            </li>
            <li *ngIf="creative.clicks">
                <span class="stats">{{creative.clicks | number}}</span>
                <span class="stats-label">Clicks</span>
            </li>
            <li *ngIf="creative.clickRate">
                <span class="stats">{{creative.clickRate}}%</span>
                <span class="stats-label">Click Rate</span>
            </li>
        </ul>
    </div>
    <div class="card-long-bg">
        <div *ngIf="creative.creativeVideo != null">
            <app-video-player [videoURL]="creative.creativeVideo"></app-video-player>
        </div>
        <div *ngIf="creative.creativeVideo == null">
            <img
                src="../../../../../../assets/images/no-creative-preview-r2.png"
                class="card-long-img creativeVideoPlaceholder"
                (click)="openModal(creativeIndex)"
                [ngClass]="{
                    c300x600: creative.creativeThumbnail.includes('300x600'),
                    c728x90: creative.creativeThumbnail.includes('728x90'),
                    c160x600: creative.creativeThumbnail.includes('160x600'),
                    c320x50: creative.creativeThumbnail.includes('320x50') || creative.creativeThumbnail.includes('300x50'),
                    c468x60: creative.creativeThumbnail.includes('468x60')
                }"
            />
        </div>
    </div>
    <div class="card-long-block">
        <div class="card-long-content">
            <div>
                <span class="percent-label">Started</span>
                <span class="percentage">
                    <div class="percent-bar primary-color-bg"
                         appTooltip title="Tooltip"
                         [title]="creative.videoCompletionPercentage.startedTooltip"
                         data-size="big"
                         [options]="tooltipOptions"
                         [ngStyle]="{'width': creative.videoCompletionPercentage.started+ '%'}"></div>
               </span>
            </div>
            <div>
                <span class="percent-label">25% Complete</span>
                <span class="percentage">
                    <div class="percent-bar primary-color-bg" appTooltip title="Tooltip"
                                              [title]="creative.videoCompletionPercentage.quarterTooltip"
                                              data-size="big"
                                              [options]="tooltipOptions"
                                              [ngStyle]="{'width': creative.videoCompletionPercentage.quarter+ '%'}"></div>
                </span>
            </div>
            <div>
                <span class="percent-label">50% Complete</span>
                <span class="percentage">
                    <div class="percent-bar primary-color-bg" appTooltip title="Tooltip"
                         [title]="creative.videoCompletionPercentage.halfTooltip"
                         data-size="big"
                         [options]="tooltipOptions"
                         [ngStyle]="{'width': creative.videoCompletionPercentage.half+ '%'}"></div>
                </span>
            </div>
            <div>
                <span class="percent-label">75% Complete</span>
                <span class="percentage">
                    <div class="percent-bar primary-color-bg" appTooltip title="Tooltip"
                         [title]="creative.videoCompletionPercentage.threeQuartersTooltip"
                         data-size="big"
                         [options]="tooltipOptions"
                         [ngStyle]="{'width': creative.videoCompletionPercentage.threeQuarters+ '%'}"></div>
                </span>
            </div>
            <div>
                <span class="percent-label">100% Complete</span>
                <span class="percentage">
                    <div class="percent-bar primary-color-bg" appTooltip title="Tooltip"
                         [title]="creative.videoCompletionPercentage.completedTooltip"
                         data-size="big"
                         [options]="tooltipOptions"
                         [ngStyle]="{'width': creative.videoCompletionPercentage.completed+ '%'}"></div>
                </span>
            </div>
        </div>
    </div>
    <div class="card-header youtube-views" *ngIf="youtubeviewspermission">
        <ul class="creative-stats">
            <li>
                <span class="stats">{{creative.youtubeVerifiedImprs | number}}</span>
                <span class="stats-label">YouTube Views</span>
            </li>
            <li>
                <span class="stats">{{creative.youtubeVerifiedImprsRate}}%</span>
                <span class="stats-label">YouTube Views Rate</span>
            </li>
        </ul>
    </div>
</div>
<div class="clear"></div>
